import { render, staticRenderFns } from "./SoldAppliancesList.vue?vue&type=template&id=51ce61b2&scoped=true"
import script from "./SoldAppliancesList.vue?vue&type=script&lang=js"
export * from "./SoldAppliancesList.vue?vue&type=script&lang=js"
import style0 from "./SoldAppliancesList.vue?vue&type=style&index=0&id=51ce61b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ce61b2",
  null
  
)

export default component.exports